export default "__VITE_ASSET__b6007690__"